import { cloneWithoutKeys } from 'Utils/objects'
import initialState from 'Checkout/Redux/InitialState'

const SEARCH_KEYS_TO_IGNORE = ['accommodation', 'checkIn', 'checkOut', 'dayUse', 'marketplaceOverrideUuid',
                               'siteType']

const SearchReducer = (currentState = {}, action) => {
  const handler = searchHandlers[action.type]
  if (handler) return handler(currentState, action)

  return currentState
}

const searchClear = (currentState, { payload: { except = SEARCH_KEYS_TO_IGNORE } }) => {
  const newState = cloneWithoutKeys(initialState.search, except)

  return { ...currentState, ...newState }
}

const searchFilterUpdate = (currentState, { payload = {} }) => ({
  ...currentState,
  ...payload,
})

const searchToggleDiscardAlert = currentState => ({
  ...currentState,
  isDiscardAlertOpen: !currentState.isDiscardAlertOpen,
})

const searchToggleModifyNotSaved = currentState => ({
  ...currentState,
  modifyNotSaved: !currentState.modifyNotSaved,
})

const searchHandlers = {
  SEARCH_CLEAR: searchClear,
  SEARCH_FILTER_UPDATE: searchFilterUpdate,
  SEARCH_TOGGLE_DISCARD_ALERT: searchToggleDiscardAlert,
  SEARCH_TOGGLE_MODIFY_NOT_SAVED: searchToggleModifyNotSaved,
}

export default SearchReducer
